// web-helper/src/components/MobileAdminPlaceholder.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const MobileAdminPlaceholder = ({ language = 'en' }) => {
  const translations = {
    en: {
      title: 'Mobile Version Coming Soon',
      description: 'The admin dashboard is optimized for desktop viewing. Please use a desktop or laptop computer to access the full admin experience.',
      features: 'Admin Dashboard Features:',
      feature1: 'View analytics and metrics',
      feature2: 'Manage conversations',
      feature3: 'Monitor system performance',
      feature4: 'Export reports',
      goBack: 'Go Back to Home',
      requirement: 'Minimum screen width required: 1024px',
    },
    es: {
      title: 'Versión Móvil Próximamente',
      description: 'El panel de administración está optimizado para visualización de escritorio. Por favor, use una computadora de escritorio o portátil para acceder a la experiencia completa de administración.',
      features: 'Características del Panel de Administración:',
      feature1: 'Ver análisis y métricas',
      feature2: 'Gestionar conversaciones',
      feature3: 'Monitorear rendimiento del sistema',
      feature4: 'Exportar informes',
      goBack: 'Volver al Inicio',
      requirement: 'Ancho mínimo de pantalla requerido: 1024px',
    },
  };

  const t = (key) => translations[language]?.[key] || translations.en[key];

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg-secondary)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--space-5)',
      }}
    >
      <div
        style={{
          maxWidth: '500px',
          width: '100%',
          background: 'var(--bg-primary)',
          borderRadius: 'var(--radius-xl)',
          padding: 'var(--space-6)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
          textAlign: 'center',
        }}
      >
        {/* Icon */}
        <div
          style={{
            fontSize: '3rem', // Icons use rem for consistent sizing
            marginBottom: 'var(--space-4)',
          }}
        >
          📱 → 💻
        </div>

        {/* Title */}
        <h1
          style={{
            color: 'var(--text-primary)',
            fontSize: 'var(--text-2xl)',
            fontWeight: 'var(--font-bold)',
            margin: '0 0 var(--space-4) 0',
          }}
        >
          {t('title')}
        </h1>

        {/* Description */}
        <p
          style={{
            color: 'var(--text-secondary)',
            fontSize: 'var(--text-base)',
            lineHeight: '1.6',
            marginBottom: 'var(--space-5)',
          }}
        >
          {t('description')}
        </p>

        {/* Features List */}
        <div
          style={{
            background: 'var(--bg-secondary)',
            borderRadius: 'var(--radius-md)',
            padding: 'var(--space-5)',
            marginBottom: 'var(--space-5)',
            textAlign: 'left',
          }}
        >
          <h3
            style={{
              color: 'var(--text-primary)',
              fontSize: 'var(--text-lg)',
              fontWeight: 'var(--font-semibold)',
              margin: '0 0 var(--space-3) 0',
            }}
          >
            {t('features')}
          </h3>
          <ul
            style={{
              margin: 0,
              paddingLeft: 'var(--space-5)',
              color: 'var(--text-secondary)',
              fontSize: 'var(--text-base)',
              lineHeight: '1.8',
            }}
          >
            <li>{t('feature1')}</li>
            <li>{t('feature2')}</li>
            <li>{t('feature3')}</li>
            <li>{t('feature4')}</li>
          </ul>
        </div>

        {/* Requirement Badge */}
        <div
          style={{
            background: 'var(--warning-bg)',
            border: '1px solid var(--warning-border)',
            borderRadius: 'var(--radius-sm)',
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-5)',
          }}
        >
          <p
            style={{
              margin: 0,
              color: 'var(--warning)',
              fontSize: 'var(--text-sm)',
              fontWeight: 'var(--font-medium)',
            }}
          >
            ⚠️ {t('requirement')}
          </p>
        </div>

        {/* Back Button */}
        <Link
          to="/"
          style={{
            background: 'var(--compudopt-blue)',
            color: 'var(--text-on-primary)',
            padding: 'var(--space-3) var(--space-5)',
            borderRadius: 'var(--radius-md)',
            textDecoration: 'none',
            fontSize: 'var(--text-base)',
            fontWeight: 'var(--font-semibold)',
            transition: 'all 0.2s ease',
            minHeight: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'var(--blue-dark)';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'var(--compudopt-blue)';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          ← {t('goBack')}
        </Link>
      </div>
    </div>
  );
};

export default MobileAdminPlaceholder;

